import { client } from "api";
import { OrderSerial } from "models/OrderSerial";

export type MoveOrderSerialRequest = {
  serialId: OrderSerial["id"];
  originalChecklistId: string;
  targetChecklistId: string;
};

export type MoveOrderSerialResponse = OrderSerial;

export const moveOrderSerial = ({ originalChecklistId, ...request }: MoveOrderSerialRequest) =>
  client
    .patch<MoveOrderSerialResponse>(`/checklist/${originalChecklistId}/move-serial`, request)
    .then((res) => res.data);
